
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IDotDongTui } from "../../../model/respone/tct/IDotDongTui";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDotDongTuiActionsObj = {
    LOAD_START: "",
    LOAD_SUCCESS: {} as IDotDongTui[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IDotDongTui | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IDotDongTui,
    SAVE_SUCCESS: {} as IDotDongTui,
    SAVE_ERROR: "",

    DELETE_START: {} as IIdsRequest,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    CHANGE_SELECTED_IDS: {} as number[]
};
export const eDotDongTuiActionIds = generateActionTypeIds(
    eDotDongTuiActionsObj,
    "DOT_DONG_TUI"
);
export type IDotDongTuiActionTypes = IGenericActionType<
    typeof eDotDongTuiActionsObj,
    "DOT_DONG_TUI"
>;
